const hashTable = function (size) {

    let storage = []

    this.printStorage = () => {
        return{storage: storage, length: storage.length}
    }

    this.hash = (str, max) => {
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash += str.charCodeAt(i)
        }
        return hash % max
    }

    this.addItem = (item) => {
        const node = this.hash(item[0], size)
        if (!storage[node]) {
            storage[node] = [item]
        } else {
            storage[node].push(item)
        }
    }

    this.deleteItem = (key) => {
        const location = this.lookupItem(key, true)
        if (location) {
            const node = location.nodeIndex
            storage[node].splice(location.itemIndex, 1)
        }
    }

    this.lookupItem = (key, returnIndex) => {
        const nodeIndex = this.hash(key, size)
        const node = storage[nodeIndex] || []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === key) {
                // return returnIndex ? { nodeIndex: nodeIndex, itemIndex: i } : node[i]
                return node[i]
            }
        }
        return null
    }

    this.purgeTable = (print) => {
        storage = []
        if (print) {
            this.printStorage()
        }
    }
}

export default hashTable